import { z } from 'zod';
import { withNewPassword } from '../../password';

export const codeRule = z
    .string()
    .trim()
    .nonempty('Enter the 6-digit code we sent to your email.')
    .regex(/^\d{6}$/, 'The code is 6 digits. Check your email for the full code.');

export const verifyAccountSchema = z.object({ verificationCode: codeRule });

/** After a refresh the password is gone (it is never stored), so /verify asks for it again. */
export const verifyWithPasswordSchema = withNewPassword({ verificationCode: codeRule });
